<template>
	<ul class="media-list" :class="[`${this.type}`]">
		<slot></slot>
	</ul>
</template>
<script>
	export default {
		props: {
			type: String
		},
		methods: {

		},
		computed: {

		},
		filters: {}
	}
</script>
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.media-list {
		&.chat {
			.media {
				.unbd;
				.pdr(10px);
				&-left:empty {
					padding-right: 0;
				}
				&-body {
					padding: 10px 15px;
					background-color: @cwh;
					.time {
						float: right;
					}
				}
				&-right {
					min-width: auto;
				}
				&.guest {
					.pdr(0);
					.media-left {
						&:empty {
							.pdr(0);
						}
					}
					.media-body {
						background-color: @ces;
						color: @cwh;
						margin: -10px -15px;
						padding: 10px 15px;
						.time {
							float: left;
							color: @cwh;
						}
						.name {
							float: right;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// medialist.vue?3ae1f00b